module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 117.eec42c16.png";